var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.535 9.341c.21.212.553.212.763 0a.544.544 0 000-.767L5.764 5.022l3.578-3.596a.545.545 0 000-.767.538.538 0 00-.764 0L5 4.254 1.422.66a.538.538 0 00-.764 0 .544.544 0 000 .767l3.578 3.596L.702 8.574a.544.544 0 000 .767c.21.212.552.212.763 0L5 5.79l3.535 3.552z",
    fill: "#6C6B6B"
  })));
}
export default SvgRemoveFile;